module.exports = __webpack_public_path__ + "img/miner4.6484e137.png";